import styled from 'styled-components'

import Icon from 'src/components/Icon'
import { mq, sizes } from 'src/theme'

export const ColumnSection = styled.div`
  position: relative;
  padding-top: 3rem;
`

export const Title = styled.h2`
  ${({ theme }) => theme.textStyles.firaSans2XlBold};
  color: ${({ theme }) => theme.colors.blueSecondaryBis};
  margin: 0;

  @media ${mq(sizes.tablet)} {
    ${({ theme }) => theme.textStyles.firaSans4XlBold};
  }
`

export const ColumnList = styled.ul`
  list-style: none;
  margin-top: 6rem;
  padding: 0;
  display: flex;
  justify-content: space-around;
  flex-wrap: wrap;

  ${({ theme }) => theme.breakpoints.down('tablet')} {
    justify-content: center;
    gap: 6rem;
  }
`

export const ColumnListItem = styled.li`
  max-width: 30.5rem;
  width: 100%;
  text-align: center;
`

export const CrossesIcon = styled(Icon)`
  position: absolute;
  top: -12rem;
  left: 0;
`
